var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdownArrowDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40445 1.08129C9.23856 0.922265 9.01416 0.833008 8.78025 0.833008C8.54635 0.833008 8.32195 0.922265 8.15606 1.08129L4.97754 4.10373L1.84329 1.08129C1.6774 0.922265 1.453 0.833008 1.2191 0.833008C0.985191 0.833008 0.760789 0.922265 0.594902 1.08129C0.511917 1.16066 0.446049 1.25509 0.4011 1.35913C0.35615 1.46318 0.333008 1.57477 0.333008 1.68748C0.333008 1.8002 0.35615 1.91179 0.4011 2.01583C0.446049 2.11988 0.511917 2.21431 0.594902 2.29368L4.34892 5.91379C4.43123 5.99381 4.52915 6.05733 4.63704 6.10068C4.74493 6.14402 4.86066 6.16634 4.97754 6.16634C5.09442 6.16634 5.21015 6.14402 5.31804 6.10068C5.42593 6.05733 5.52385 5.99381 5.60616 5.91379L9.40445 2.29368C9.48743 2.21431 9.5533 2.11988 9.59825 2.01583C9.6432 1.91179 9.66634 1.8002 9.66634 1.68748C9.66634 1.57477 9.6432 1.46318 9.59825 1.35913C9.5533 1.25509 9.48743 1.16066 9.40445 1.08129Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowDownIcon);
export default __webpack_public_path__ + "static/media/dropdown-arrow-down-icon.cae26549e350dc1fef0948817d4b07e1.svg";
export { ForwardRef as ReactComponent };